/**
 * Created by rhinov15 on 04/01/2016.
 */
/**
 * Graphical node for representing junction point when selected or hovered
 *
 */

import { Entity, Wall } from "@rhinov/savane-js";


declare var cc: any;

export class JoineryExtremitiesNode extends cc.DrawNode {
    constructor(wall: Wall, entity: Entity) {
        super()
        // Compute sprite size depending on wall thickness
        this._squareHalfSize = (wall.thickness / 2) * 0.1;
        // But carefull not to be too big or too small
        this._squareHalfSize = Math.min(this._squareHalfSize, JoineryExtremitiesNode.SQUARE_HALF_SIZE_MAX);
        this._squareHalfSize = Math.max(this._squareHalfSize, JoineryExtremitiesNode.SQUARE_HALF_SIZE_MIN);
        // Compute node rotation
        this.computeAngle(wall);
        // Load texture image
        /*        this._sprite = new cc.Sprite(CocosConstants.resourcesBasePath + '/resources/selectedDrop.png');
                // Set sprite size
                this._sprite.setScale(this._squareHalfSize * 2/(this._sprite.width*2.5), this._squareHalfSize * 2 / (this._sprite.height*2.5));
                // Add sprite to the renderer
                this.addChild(this._sprite);*/


        //Colors
        var yellow = new cc.color('#F5D231');
        var grey = new cc.Color(66, 80, 94, 255);

        if (entity.locked) {
            yellow = new cc.color(255, 125, 141, 255)
        }

        var radius = 3;
        this.drawDot(new cc.p(0, 0), radius + 2, grey);
        this.drawDot(new cc.p(0, 0), radius, yellow);
    }

    // Set node rotation according to the wall holding the joinery direction
    computeAngle (wall: Wall) {
        var angle = 0;

        if (wall !== null) {
            angle = Math.atan2(wall.wallDirection[0], wall.wallDirection[1]);
        }
        angle = (angle - Math.PI * 0.5) * 180 / Math.PI;
        this.setRotation(angle);
    }

    // Set rotation and position of the node
    computeExtremity (position: any, wall: Wall) {
        this.computeAngle(wall);
        this.setPosition(position);
    }
    /**
     * Remove listener added for zoomUpdate
     */
    removeListener () {
        // Nothing to do here, no listener attached to this type of node
    }
}

JoineryExtremitiesNode.SQUARE_HALF_SIZE_MAX = 16;
JoineryExtremitiesNode.SQUARE_HALF_SIZE_MIN = 12;
